import { AlertParamsType, ConfirmParamsType, DialogStoreType } from '@/types/dialog';
import { defineStore } from 'pinia';

export const useDialogStore = defineStore({
  id: 'dialog',
  state: (): DialogStoreType => ({
    dialogOption: {
      open: false,
      message: '',
      buttonText: '',
      title: '',
      type: 'alert',
      callback: () => {},
    },
  }),
  getters: {},
  actions: {
    openAlert(value: AlertParamsType) {
      this.dialogOption = {
        open: true,
        title: value.title,
        message: value.message,
        buttonText: value.buttonText,
        type: 'alert',
        callback: value.callback ? value.callback : () => {},
      };
    },
    closeAlert(callback?: AlertParamsType['callback']) {
      this.dialogOption = {
        open: false,
        title: '',
        message: '',
        buttonText: '',
        type: 'alert',
        callback: callback ? callback : () => {},
      };
    },
    openConfirm(value: ConfirmParamsType) {
      this.dialogOption = {
        open: true,
        message: value.message,
        title: value.title,
        buttonText: value.buttonText,
        type: 'confirm',
        callback: value.callback ? value.callback : () => {},
      };
    },
    closeConfirm(callback?: ConfirmParamsType['callback']) {
      this.dialogOption = {
        open: false,
        message: '',
        title: '',
        buttonText: '',
        type: 'confirm',
        callback: callback ? callback : () => {},
      };
    },
  },
});
